import Link from "../../common/components/modules/Link";
import routes from "../../common/routes";
import React from "react";
import useQueryParams from "src/core/common/hooks/useQueryParams";

function GoToLogin({replace = false}) {
  const [params] = useQueryParams(["redirect"]);
  return (
    <>
      Already a member?{" "}
      <Link
        replace={replace}
        to={{pathname: routes.login, query: params.redirect ? params : {}}}
      >
        Log in.
      </Link>
    </>
  );
}

export default GoToLogin;
